const moduleState = {
  establishments: [],
}

const getters = {
  availableEstablishments: (state) =>
    state.establishments.map((x) => {
      return { text: `${x.Name} - ${x.City}`, value: x.EstablishmentNumber }
    }),
  establishmentById: (state) => (establishmentId) =>
    state.establishments.find((x) => x.EstablishmentNumber == establishmentId),
}

const mutations = {
  setEstablishments(state, payload) {
    state.establishments = payload
  },
}

const actions = {
  setEstablishments: ({ commit }, payload) => {
    commit('setEstablishments', payload)
  },
}

export default {
  state: moduleState,
  mutations,
  actions,
  getters,
  namespaced: true,
}
